export default __webpack_public_path__ + "static/media/img-0447-luxembourg-full-face.7c813e01.png";